export enum SizeGroupTypeEnum {
  adult = 0,
  youth = 1,
  kid = 2,
  infant = 3,
}
